module.exports = __webpack_public_path__ + "img/gas-detection.b6bfe679.jpg";